// Port of api/fuel/app/classes/filter/search/games/rules/query/version_size_weight.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'version_size_weight',
	field: function() { return 'v.game_version_storage_weight' }
})
